import React from "react";
import PropTypes from "prop-types";
// Material imports
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useExpertProfileContext } from "../../../expert";
const PolicyScreeningContainer = ({
  policy,
  showWarning = true,
  children
}) => {
  const {
    canUserAccess
  } = useExpertProfileContext();
  let allowAccessList = false;
  if (typeof policy === "string") {
    allowAccessList = canUserAccess(policy);
  } else {
    policy.forEach(p => {
      const hasPermission = canUserAccess(p);
      if (hasPermission) {
        allowAccessList = true;
      }
    });
  }
  if (!allowAccessList && showWarning) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justifyContent: "center",
      alignItems: "center",
      style: {
        backgroundColor: "#fff"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "You have insufficient permission to view this page"));
  } else if (allowAccessList) {
    return children;
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
export default PolicyScreeningContainer;
PolicyScreeningContainer.propTypes = {
  policy: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  children: PropTypes.node.isRequired,
  showWarning: PropTypes.bool
};